export enum SharedServiceEnum {
    shareTv = 'share-tv',
    shareAntiSpamAppels = 'share-anti-spam',
}
